import parse from "../parse";
import { CourseLengthsClass } from "../../constants/classes";

export default async function getCourseLengths() {
  const courseLengths = parse.Object.extend(CourseLengthsClass);
  const query = new parse.Query(courseLengths);
  return await query.find();
}
